import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import StoreLocatorIcon from './storeLocatorIcon.svg';
import { LoginDropdown, ShoppingBag } from '../../../../Containers/Desktop/HeaderContainer/HeaderContainer';
// import HoverIntent from 'react-hoverintent';

export class MyDillardsBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showMyDillardsLogo: false,
      showAccountDD: false,
      loaded: false,
    };
    this.state.mouseover = false;
    this.handleShowDillardsLogo = this.handleShowDillardsLogo.bind(this);
  }

  preventDoubleClick() {
    if (document.getElementsByClassName('shopping-bag-count-container')[0]) {
      document.getElementsByClassName('shopping-bag-count-container')[0].style.pointerEvents = 'none';
    }
  }

  handleShowDillardsLogo() {
    if (this.props.passedAppFunctions.siteFormat === 'desktop') {
      const initialPosition = window.scrollY || document.documentElement.scrollTop;

      const dillardsBarWrapper = document.querySelector('#my_dillards_bar_wrapper');
      if (!dillardsBarWrapper) return;

      if (dillardsBarWrapper.getBoundingClientRect().top <= 1 && initialPosition > 0) {
        if (!this.state.showMyDillardsLogo) {
          document.getElementById('backgroundContainer').classList.add('dropShadow');
          this.setState({ showMyDillardsLogo: true });
        }
      } else {
        if (this.state.showMyDillardsLogo) {
          document.getElementById('backgroundContainer').classList.remove('dropShadow');
          this.setState({ showMyDillardsLogo: false });
        }
      }
    }
  }

  componentDidMount() {
    if (this.props.passedAppFunctions.siteFormat == 'desktop') {
      this.handleShowDillardsLogo();
    }
    window.addEventListener('scroll', this.handleShowDillardsLogo);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleShowDillardsLogo);
  }

  render() {
    let { mouseover } = this.state.mouseover;

    return (
      <div id='myDillardsBarContainer'>
        <div
          id='my_dillards_bar_wrapper'
          tabIndex='-1'
          className={`dillardsBarPromo ${this.state.showMyDillardsLogo ? 'backgroundBlack' : ''}`}
          onTouchEnd={this.props.closeMenu}
        >
          <div className={`${this.props.passedAppFunctions.siteFormat == 'tablet' ? 'container' : 'container-fluid'}`}>
            <div className='mdbContainer__row row m-0'>
              <div className='col-sm-12'>
                <ul className='barItems'>
                  <li className='logoListitem'>
                    {this.props.passedAppFunctions.siteFormat == 'desktop' ? (
                      <Link to='/' rel='nofollow' className='logo-spot'>
                        <img
                          className='myDillardsLogo'
                          src='https://dimg.dillards.com/is/image/DillardsZoom/smallDillardsLogo?fmt=png-alpha&bfc=on&wid=119&hei=30&qlt=90,1&resMode=sharp2'
                          width='59'
                          height='15'
                          alt="Dillard's Logo"
                        ></img>
                      </Link>
                    ) : (
                      ''
                    )}
                  </li>
                  {!this.state.showMyDillardsLogo && (
                    <>
                      <li className='barItems__li'>
                        <Link to='/c/back-in-stock' manual_cm_sp='Header-_-BackInStock-_-TextLink'>
                          Back In Stock
                        </Link>
                      </li>
                      <li className='barItems__li'>
                        <Link
                          to='/c/sale-clearance'
                          manual_cm_sp='Header-_-SaleClearance-_-TextLink'
                          className='sale-clearance text--clearance'
                        >
                          Sale and Clearance
                        </Link>
                      </li>
                      <li className='barItems__li'>
                        <Link to='/c/shopbybrand' manual_cm_sp='Header-_-ShopByBrand-_-TextLink'>
                          Shop By Brand
                        </Link>
                      </li>
                      <li className='barItems__li'>
                        <Link
                          to='/c/limited-availability'
                          manual_cm_sp='Header-_-LimitedAvailability-_-TextLink'
                          className='text--limitedAvailability'
                        >
                          Limited Availability
                        </Link>
                      </li>
                      <li className='barItems__li hide-when-international'>
                        <Link
                          to='/c/DillardsCard?cmp=A~H~A~Z~8~E~ZZZ1~CC~DL~LC'
                          manual_cm_sp='Header-_-CreditCard-_-TextLink'
                          className='text--creditCard citi-link'
                        >
                          Credit Card
                        </Link>
                      </li>
                      <li className='headerStoreLocatorLink barItems__li pr-0 hide-when-international'>
                        <StoreLocatorIcon />
                        <a href='/stores' manual_cm_sp='headerPromo-_-storeLocator'>
                          Find a Store
                        </a>
                      </li>
                    </>
                  )}
                  {this.state.showMyDillardsLogo ? (
                    <>
                      <li id='blackBarAccountDD'>
                        <LoginDropdown
                          passedAppFunctions={this.props.passedAppFunctions}
                          myDillardsInfo={this.props.myDillardsInfo}
                          siteFormat={this.props.passedAppFunctions.siteFormat}
                        />
                      </li>
                      <li id='blackBarShoppingBag'>
                        <ShoppingBag
                          passedAppFunctions={this.props.passedAppFunctions}
                          myDillardsInfo={this.props.myDillardsInfo}
                        />
                      </li>
                    </>
                  ) : (
                    ''
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MyDillardsBar.propTypes = {
  handleMyDillardsBoxClick: PropTypes.func,
};

export default MyDillardsBar;
